import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { WindowSize } from '@models/window-size';
import { Observable, map, startWith } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PlatformService {
    constructor(private platform: Platform) {}

    isMobile(): boolean {
        return this.platform.is('android') || this.platform.is('iphone') || this.platform.is('ipad');
    }

    resize: Observable<WindowSize> = this.platform.resize.asObservable().pipe(
        startWith(undefined),
        map<void, WindowSize>((_) => ({ height: innerHeight, width: innerWidth }))
    );

    /**
     * Returns `true` if application runs in a browser (so it must have been built as a PWA), for example:
     * - Chrome on Windows
     * - Chrome on Android
     * - Safari on iOS
     *
     * Returns `false` when it's a native app, for example:
     * - Android native *.apk package running on a physical device
     * - Android native *.apk package running on an emulated device (e.g. qemu bundled with Android Studio)
     * - iPhone app package running on a physical iPhone
     */
    isWeb(): boolean {
        const isAndroidOrIos = this.platform.is('android') || this.platform.is('ios');
        const isWeb =
            (isAndroidOrIos && this.platform.is('mobileweb')) ||
            this.platform.is('desktop') ||
            (!isAndroidOrIos && this.platform.is('mobileweb') && this.platform.is('mobile'));
        return isWeb;
    }

    backButtonClicked(): Observable<boolean> {
        return this.platform.backButton.asObservable().pipe(map((x) => true));
    }
}
